<template>
  <div class="goodnessG" >
    <div v-html="pageCate.info.content"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "goodnessG",
  computed: mapGetters(["pageCate"]),
};
</script>

<style scoped lang='less'>
</style>


// WEBPACK FOOTER //
// src/components/go/goodnessG.vue